(function () {
    "use strict";

    angular.module("sempraWebapp").controller("RolloverController", RolloverController);

    /** @ngInject */
    function RolloverController(
        $scope,
        $state,
        $stateParams,
        $translate,
        $timeout,
        $mdDialog,
        dashboardKarcherActions,
        layoutActions,
        dialogsService,
        checkUserRole
    ) {
        var vm = this;

        vm.sites = [];
        vm.vouchers = {
            data: [],
            page: 1,
            pageSize: 10,
            total: 0,
            pageOptions: [10, 25, 50, 100],
            pagerTranslations: {
                page: 'Page:',
                rowsPerPage: 'Rows per page:',
                of: 'of'
            }
        };
        vm.selectedSiteId = null;
        vm.isLoading = true;
        vm.isLoadingVouchers = false;
        vm.siteName = '';
        vm.voucherFilter = '';
        vm.vouchersForPrint = [];
        vm.issuedDateLabel = $translate.instant('ISSUED_DATE');
        vm.expiryDateLabel = $translate.instant('EXPIRY_DATE');
        vm.tokensLabel = $translate.instant('ROLLOVER_VOUCHER_TOKENS');
        vm.remainingWashesLabel = $translate.instant('ROLLOVER_REMAINING_WASHES');
        vm.isCashier = checkUserRole.isCashier() && !checkUserRole.isMerchantAdmin();
        vm.isMerchantAdmin = checkUserRole.isMerchantAdmin();
        vm.onSiteChange = onSiteChange;
        vm.selectSiteForCreate = selectSiteForCreate;
        vm.filterVouchers = filterVouchers;
        vm.deactivateVoucher = deactivateVoucher;
        vm.printVoucher = printVoucher;

        init();

        function init() {
            $scope.$on("$destroy", onDestroyHandler);
            loadSites();
        }

        function onDestroyHandler() {
            vm.sites = [];
            vm.vouchers.data = [];
            vm.vouchers.total = 0;
            vm.voucherFilter = '';
        }

        function loadSites() {
            vm.isLoading = true;
            layoutActions.showLoader();
            dashboardKarcherActions.getKarcherSitesData('', '').then(
                function (response) {
                    vm.sites = response.siteAlarmStatusDtos || [];
                    
                    // Single site - go directly to create voucher page (unless coming from create page)
                    if (vm.sites.length === 1 && !$stateParams.showList) {
                        vm.isLoading = false;
                        layoutActions.hideLoader();
                        $state.go('app.rolloverPrograms', { siteId: vm.sites[0].siteId });
                        return;
                    }
                    
                    // Show vouchers list for single site
                    if (vm.sites.length === 1 && $stateParams.showList) {
                        vm.selectedSiteId = vm.sites[0].siteId;
                        vm.siteName = vm.sites[0].siteName;
                        loadVouchers(vm.sites[0].siteId);
                    }
                    
                    // Multiple sites - show site selection
                    if (vm.sites.length > 1) {
                        vm.isLoading = false;
                        layoutActions.hideLoader();
                    } else {
                        vm.isLoading = false;
                        layoutActions.hideLoader();
                    }
                },
                function () {
                    vm.isLoading = false;
                    layoutActions.hideLoader();
                }
            );
        }

        function onSiteChange() {
            if (vm.selectedSiteId) {
                $state.go('app.rolloverPrograms', { siteId: vm.selectedSiteId });
            }
        }

        function selectSiteForCreate(siteId) {
            $state.go('app.rolloverPrograms', { siteId: siteId || vm.selectedSiteId });
        }

        function loadVouchers(siteId) {
            vm.isLoadingVouchers = true;
            var page = vm.vouchers.page - 1; // Backend uses 0-indexed pages
            dashboardKarcherActions.getRolloverVouchersBySite(siteId, page, vm.vouchers.pageSize, vm.voucherFilter).then(
                function (response) {
                    vm.vouchers.data = response.content || [];
                    vm.vouchers.total = response.totalElements || response.total || 0;
                    vm.isLoadingVouchers = false;
                },
                function () {
                    vm.vouchers.data = [];
                    vm.vouchers.total = 0;
                    vm.isLoadingVouchers = false;
                }
            );
        }

        function filterVouchers() {
            vm.vouchers.page = 1; // Reset to first page when searching
            loadVouchers(vm.selectedSiteId);
        }

        vm.pageChanged = function (page, limit) {
            vm.vouchers.page = page;
            vm.vouchers.pageSize = limit;
            loadVouchers(vm.selectedSiteId);
        };

        function deactivateVoucher(voucher) {
            if (voucher.status !== 'ACTIVE') {
                return;
            }
            
            dialogsService.showConfirmDialog(
                "ROLLOVER_DEACTIVATE_TITLE",
                "ROLLOVER_DEACTIVATE_CONFIRM",
                "PROCEED"
            ).then(function () {
                layoutActions.showLoader();
                dashboardKarcherActions.deactivateRolloverVoucher(voucher.id).then(
                    function (updatedVoucher) {
                        // Update the voucher in the list
                        var index = vm.vouchers.data.findIndex(function(v) {
                            return v.id === voucher.id;
                        });
                        if (index !== -1) {
                            vm.vouchers.data[index] = updatedVoucher;
                        }
                        layoutActions.hideLoader();
                    },
                    function () {
                        layoutActions.hideLoader();
                    }
                );
            });
        }

        function printVoucher(voucher) {
            vm.vouchersForPrint = [];
            vm.vouchersForPrint.push(voucher);
            $timeout(function () {
                window.print();
                // Show confirmation dialog after print
                showPrintConfirmDialog(voucher.voucherCode);
            }, 0);
        }

        function showPrintConfirmDialog(voucherCode) {
            $mdDialog.show({
                controller: PrintConfirmDialogController,
                controllerAs: 'dialog',
                templateUrl: 'app/rollover/rolloverPrintConfirmDialog.html',
                parent: angular.element(document.body),
                clickOutsideToClose: false,
                escapeToClose: false,
                locals: {
                    voucherCode: voucherCode,
                    onConfirm: function() {
                        // Stay on the same page, just close the dialog
                    }
                }
            });
        }

        /** @ngInject */
        function PrintConfirmDialogController($mdDialog, voucherCode, onConfirm) {
            var dialog = this;
            dialog.voucherCode = voucherCode;

            dialog.confirm = function() {
                $mdDialog.hide();
                onConfirm();
            };
        }
    }
})();
